import { render, staticRenderFns } from "./bill_detail.vue?vue&type=template&id=097b404b&scoped=true"
import script from "./bill_detail.vue?vue&type=script&lang=js"
export * from "./bill_detail.vue?vue&type=script&lang=js"
import style0 from "./bill_detail.vue?vue&type=style&index=0&id=097b404b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b404b",
  null
  
)

export default component.exports